import { Injectable } from '@angular/core';

import { ToasterService, ToasterContainerComponent, ToasterConfig } from 'angular2-toaster/angular2-toaster';

@Injectable()
export class ToasterModalUtilService {

    
    constructor(private toasterServiceModal: ToasterService) {
    }

    alerta(msg: string) {
        this.toasterServiceModal.pop('warning','Alerta', msg);
    }
}


// WEBPACK FOOTER //
// ./src/app/util/toaster-modal-util.service.ts